import React from 'react';

import {useTranslation} from 'react-i18next';

import {PermissionAccess} from 'components/common/PermissionAccess';
import {NavBar, NavLink} from 'components/ui-kit/NavBar';
import {ROUTE} from 'core/routes';

import {UserPermission} from 'types';

export const GridsNavigation = () => {
    const {t} = useTranslation();
    return (
        <PermissionAccess>
            <NavBar>
                <NavLink exact to={ROUTE.BILLING}>
                    {t('pages.profile.billing.gridName.transactions')}
                </NavLink>
                <NavLink exact to={ROUTE.BILLING_INVOICES}>
                    {t('pages.profile.billing.gridName.invoices')}
                </NavLink>
            </NavBar>
        </PermissionAccess>
    );
};
